import { FieldSize } from 'shared/types/fieldSize';

export const MAX_FILES = 50;
export const MAX_FILE_NAME_LENGTH = FieldSize.FILE_NAME;
export const MAX_DISPLAY_FILE_SIZE = 500000;
